import {Context} from '@nuxt/types/app';
import carTax from '@pp-frontend/shared-packages/modules/car-tax-calc/store/car-tax';

/**
 * Стор с налоговыми ставками для авто
 */
export default function ({store}: Context) {
  store.registerModule('car-tax', carTax)
}
